import {useModal} from "vue-final-modal";
import ConfirmModal from "~/components/modal/ConfirmModal.vue";
import type {ButtonDto} from "~/entities/button/ButtonDto";

export function useModalConfirm(title: string, confirm: ButtonDto, cancel?: ButtonDto): Promise<boolean> {
  return new Promise(resolve => {
    const useAppModal = useModal({
      component: ConfirmModal,
      attrs: {
        title,
        confirm,
        cancel,
        onConfirm() {
          resolve(true);
          useAppModal.close();
        },
        onCancel() {
          resolve(false);
          useAppModal.close();
        },
      }
    });

    useAppModal.open();
  });
}